import ieee_conecct_award from '../../images/ieee_conecct_award.png';

export const meta = {
  id: 5,
  title: "7 Papers Accepted at IEEE CONECCT",
  date: "July 2026",
  readTime: "2 min read",
  coverImage: ieee_conecct_award,
  tags: ["Research", "IEEE CONECCT", "Publications"],
  excerpt: "Successfully got 7 research papers accepted at the prestigious IEEE CONECCT conference.",
};

export const content = `
We are incredibly excited and honored to announce that **7 of our research papers** have been accepted for presentation and publication at the prestigious **IEEE CONECCT** conference! 🎉

This is a monumental milestone in our research journey. The accepted papers cover a wide range of topics, reflecting months of rigorous experimentation, deep learning model development, and innovative problem-solving.

A special shoutout and credits to **Sanvi Sharma**, the main author and contributor, for her exceptional work, and to **Nishanth Shet** for brilliantly presenting the research. A huge thank you to all my mentors, collaborators, and peers for their continuous support and guidance throughout this process. This achievement wouldn't have been possible without them.

Looking forward to presenting these papers at the conference and engaging in insightful discussions with fellow researchers and domain experts from around the world.

More updates and detailed links to the papers will be shared soon after the conference proceedings are published! 🚀

---

![IEEE CONECCT Award](${ieee_conecct_award})

#Research #IEEE #CONECCT #Publications #MachineLearning #DeepLearning
`;
